/**
 * Stable empty arrays for React Query `data = []` defaults.
 * Inline `[]` defaults create a new reference every render while data is undefined,
 * which can trigger infinite useEffect loops when used as a dependency.
 */
export const STABLE_EMPTY_COACHES: import('@court-sync/shared').Coach[] = [];
